import * as React from "react";
import { Alert } from "components/bootstrap";
const FetchErrorAlert = ({ message, error = null }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, message, ": ", (_a = error == null ? void 0 : error.message) != null ? _a : "Unknown error");
};
export default FetchErrorAlert;
